var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4542 15.0271L12.4542 15.0271C12.7761 15.2576 13.2239 15.2576 13.5458 15.0271L13.5458 15.0271L22.2 8.82984V7.63177C22.2 7.20077 21.8282 6.8 21.3051 6.8H4.69492C4.17178 6.8 3.8 7.20077 3.8 7.63177V8.82985L12.4542 15.0271Z",
    stroke: "#919DA9",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 12.1592V18.6622C21.4375 19.0919 21.087 19.4415 20.6562 19.4415H5.34375C4.91297 19.4415 4.5625 19.0919 4.5625 18.6622V12.1592L3 11V18.6622C3 19.9513 4.05141 21 5.34375 21H20.6562C21.9486 21 23 19.9513 23 18.6622V11L21.4375 12.1592Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.f22b632d7579118109aa2922e829c43f.svg";
export { ForwardRef as ReactComponent };